<template>
  <div
    class="wspo-select-options"
    :class="{ 'wspo-select-options-max': size === 'max' }"
    :show="open"
  >
    <div
      class="wspo-select-option"
      v-for="option in options"
      :key="option.id"
      :data-id="option.id"
      @click="onSelect"
      :class="{ 'wspo-selected': option.id === selected }"
    >
      {{ option.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Options',
  props: {
    open: Boolean,
    type: [String, Number],
    size: String,
    options: Array,
    onSelect: Function,
    selected: [Number, String]
  }
};
</script>

<style scoped>
.wspo-select-options {
  background: var(--color-paper);
  padding: 4px;
  max-height: 400px;
  max-width: 100vw;
  overflow-y: auto;
  position: absolute;
  min-width: calc(100% - 16px);
  z-index: 1;
  box-shadow: 0 0 1px var(--color-alt), 0 0 8px var(--color-bg-dark),
    1px 0 12px var(--color-bg);
}

.wspo-select-options-max {
  columns: 8 80px;
  column-fill: auto;
  column-gap: 0;
  column-rule-width: 0;
  width: 960px;
  max-width: calc(100vw - 60px);
}
@media (max-width: 1600px) {
  .wspo-select-options-max {
    width: calc(66vw - 60px);
  }
}
@media (max-width: 800px) {
  .wspo-select-options-max {
    width: calc(50vw - 60px);
  }
}
@media (max-width: 575px) {
  .wspo-select-options-max {
    columns: unset;
  }
}
.wspo-select-option {
  display: inline-flex;
  padding: 4px 8px;
  font-size: 13px;
  width: 100%;
  overflow: hidden;
  border: 1px solid var(--color-paper);

  border-radius: 2px;
}
.wspo-select-option:hover:not(.wspo-selected) {
  background: var(--color-bg-dark);
  border: 1px solid var(--color-alt-5);
  cursor: pointer;
}
.wspo-selected {
  background-color: var(--color-main);
  color: var(--color-paper);
}
</style>
